import {BasketItem} from "../Types/BasketItem";
import {WeeklyDish} from "../Types/WeeklyDish";

export const readBasket = (): BasketItem[] => {
  const stored = localStorage.getItem("basket");
  return stored ? JSON.parse(stored) : [];
}

export const addToBasket = (parsedAmount: number, dish: WeeklyDish) => {
  const basket: BasketItem[] = readBasket();

  const existingIndex = basket.findIndex((it) => it.id === dish.menuItem.id);

  if (existingIndex !== -1) {
    // if menu item alr exists in basket, add up instead of making a new one
    const existing = basket[existingIndex];
    const newQuantity = existing.quantity + parsedAmount;

    if (newQuantity > dish.dishAmount) {
      alert(`Je hebt al ${existing.quantity} stuks in je mandje. Maximaal ${dish.dishAmount} beschikbaar.`);
      return;
    }

    basket[existingIndex] = { ...existing, quantity: newQuantity };
  } else {
    basket.push({
      id: dish.menuItem.id!,
      name: dish.menuItem.name,
      price: dish.menuItem.price,
      quantity: parsedAmount,
    });
  }

  localStorage.setItem("basket", JSON.stringify(basket));
}

export const removeBasketItem = (id: number): BasketItem[] => {
  const items: BasketItem[] = readBasket();

  const next = items.filter((it) => it.id !== id);
  try {
    localStorage.setItem("basket", JSON.stringify(next));
  } catch {
  }
  return next;
}

export const emptyBasket = () => {
  localStorage.removeItem("basket");
}